import QueryString from "qs"
import http from "../index"
import {apiListPackages, apiPackageDetail, apiPackageCreate, apiPackageUpdate, apiPackageDelete, apiListPackagesLeader, apiPackageDetailLeader, apiBuyPackageLeader} from "./urls"

const listPackages  = (params) => http.get(apiListPackages, {params})
const packageDetail = (id) => http.get(apiPackageDetail(id))
const packageCreate = (body) => http.post(apiPackageCreate, body)
const packageUpdate = (id, body) => http.put(apiPackageUpdate(id), body)
const packageDelete = (params) => http.delete(apiPackageDelete,{ params })
const packageBrowse = (id, body) => http.put(`1.0/wsm/package/${id}/browse`, body)
const packageRefuse = (id, body) => http.put(`1.0/wsm/package/${id}/refuse`, body)

// Leader
const listPackagesLeader  = (params) => http.get(apiListPackagesLeader, {params})
const packageDetailLeader = (id) => http.get(apiPackageDetailLeader(id))
const buyPackageLeader = ( body) => http.post(apiBuyPackageLeader, body)
const PackageService = {
    listPackages,
    packageDetail,
    packageCreate,
    packageUpdate,
    packageDelete,
    packageBrowse,
    packageRefuse,
    listPackagesLeader,
    packageDetailLeader,
    buyPackageLeader,

}
export default PackageService